<template>
  <div id="config-flow-screen">
    <font-awesome-icon
      key="close-button"
      class="close-button"
      :icon="'times'"
      size="4x"
      @click="close"
    />
    <font-awesome-icon
      v-if="step > 0"
      key="back-button"
      class="back-button"
      :icon="'chevron-left'"
      size="4x"
      @click="back"
    />
    <transition appear name="fade" mode="out-in">
      <div :key="`step${step}`" class="steps">
        <p class="title" v-html="$t(`configFlow.step${step}.title`)"></p>
        <div class="sub-pages">
          <carousel
            class="carousel"
            :autoplay="false"
            :is-touch="true"
            :per-page="1"
            :mouse-drag="false"
            :loop="true"
            v-model="currentSubPageIndex"
          >
            <slide v-for="(subPage, index) in currentPage.subPages" :key="index">
              <div class="basic-box sub-page-box">
                <img class="image" v-if="subPage.image" :src="subPage.image" alt />
                <p class="sub-title" v-html="$t(`configFlow.step${step}.title${index}`)"></p>
                <p
                  key="description"
                  class="sub-description"
                  v-html="$t(`configFlow.step${step}.description${index}`)"
                ></p>
              </div>
            </slide>
          </carousel>
        </div>
        <p class="button-row">
          <base-button
            @click="next"
            :text="$t(`configFlow.step${step}.subPage${currentSubPageIndex}.nextButtonText`)"
            class="next-button"
          />
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import BaseButton from '@/components/shared/elements/BaseButton';
import InviteModal from '@/components/shared/modals/InviteModal';

export default {
  name: 'ConfigFlowScreen',
  components: { BaseButton, Carousel, Slide },
  props: {
    isDemo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      step: 0,
      currentSubPageIndex: 0,
      pages: [
        {
          subPages: [{}, {}, {}, {}],
        },
        {
          subPages: [{}, {}, {}, {}],
        },
        {
          subPages: [
            {},
            {
              image: '/static/images/categories/0.png',
            },
            {
              image: '/static/images/categories/1.png',
            },
            {
              image: '/static/images/categories/2.png',
            },
            {
              image: '/static/images/categories/3.png',
            },
            {
              image: '/static/images/categories/4.png',
            },
            {
              image: '/static/images/categories/5.png',
            },
            {
              image: '/static/images/categories/6.png',
            },
          ],
        },
        {
          subPages: [{}, {}, {}, {}, {}, {}],
        },
      ],
      categories: [
        {
          type: 0,
          icon: 'seedling',
        },
        {
          type: 1,
          icon: 'rocket',
        },
        {
          type: 2,
          icon: 'smile-beam',
        },
        {
          type: 3,
          icon: 'users',
        },
        {
          type: 4,
          icon: 'gift',
        },
        {
          type: 5,
          icon: 'cogs',
        },
        {
          type: 6,
          icon: 'bell',
        },
        {
          type: 7,
          icon: 'seedling',
        },
        {
          type: 8,
          icon: 'umbrella-beach',
        },
      ],
    };
  },
  computed: {
    currentPage() {
      return this.pages[this.step];
    },
  },
  methods: {
    ...mapActions({
      configurateCompany: 'users/configurateCompany',
    }),
    close() {
      this.$eventBus.hideConfig();
    },
    back() {
      this.step -= 1;
      this.currentSubPageIndex = 0;
    },
    categoryForIndex(index) {
      return this.categories[index];
    },
    next() {
      if (
        this.step === 3 &&
        this.currentSubPageIndex === this.currentPage.subPages.length - 1
      ) {
        if (this.isDemo) {
          this.$eventBus.hideConfig();
        } else {
          this.configurateCompany({}).then(() => {
            this.$swal(
              this.$t('configFlow.success.title'),
              this.$t('configFlow.success.message'),
              'success',
            ).then(() => {
              this.$eventBus.showModal({
                bind: {
                  is: InviteModal,
                },
              });
            });
            this.$eventBus.hideConfig();
          });
        }
        return;
      }
      if (this.currentSubPageIndex === this.currentPage.subPages.length - 1) {
        this.currentSubPageIndex = 0;
        this.step += 1;
        return;
      }
      this.currentSubPageIndex += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
$windowWidth: 1280px;
$windowHeight: 768px;
$usedWindowRate: 100vw / $windowWidth;
@keyframes alternativePulse {
  0% {
    $smallSize: 100px * $usedWindowRate;
    width: $smallSize;
    height: $smallSize;
    opacity: 1;
    transform: translate(-($smallSize / 2), -($smallSize / 2));
  }
  100% {
    $bigSize: 200px * $usedWindowRate;
    width: $bigSize;
    height: $bigSize;
    opacity: 0;
    transform: translate(-($bigSize / 2), -($bigSize / 2));
  }
}
#config-flow-screen {
  overflow: auto;
  background: red url("/static/images/upper_logo.svg");
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  .steps {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
  }
  .pulsation-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 4%;
  }

  .sub-pages {
    min-height: 50%;
    .sub-page-box {
      min-height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .image {
        max-height: 100px;
      }
    }
  }
  .pulsation {
    background-color: #50e3c2;
    position: absolute;
    animation: alternativePulse 1.5s infinite;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    z-index: 0;
  }
  .transition-group {
    width: 100%;
    height: 100%;
  }
  .next-button {
    min-width: 350px;
    width: 30%;
    >>> .base-button {
      background-color: #50e3c2;
      font-size: 80%;
      &:hover {
        background-color: #1d9e81;
      }
    }
  }
  .title {
    font-size: 32px;
    font-weight: bold;
  }
  .sub-title {
    font-size: 28px;
    font-weight: bold;
  }
  .sub-description {
    font-size: 22px;
    font-weight: 100;
  }
  .VueCarousel-slide {
    padding: 1em;
  }
  .carousel {
    width: 800px;
    margin: 0 auto;
    >>> .VueCarousel-dot {
      outline: none !important;
      background-color: #1d9e81 !important;
      opacity: 0.5;
      &.VueCarousel-dot--active {
        opacity: 1;
        background-color: #50e3c2 !important;
      }
    }
  }
  .close-button,
  .back-button {
    position: absolute;
    font-size: 20px;
    color: #aaa;
    cursor: pointer;
    &:hover {
      color: $base-font-color;
    }
  }
  .close-button {
    top: 2%;
    right: 2%;
  }
  .back-button {
    top: 2%;
    left: 2%;
  }
}
</style>
